// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"71fe28e9","777":"296ea028","787":"6c61533a"}[chunkId] + ".chunk.js";
};